import { gridStandings } from "../components/tournament-brackets";

let btn_standings = document.querySelectorAll(".standings__button-stage");
let box = $(".standings__bracket");
let tables = document.querySelectorAll(".standings__table");
let loader = document.querySelector(".standings__loader");
for (let i = 0; i < btn_standings.length; i++) {
  btn_standings[i].addEventListener("click", function() {
    let ids = this.getAttribute("data-substage").split(",");
    let type = this.getAttribute("data-type").split(",");
    let gameID = this.getAttribute("data-game-id");
    box.empty();
    let loading = false;

    for (let j = 0; j < type.length; j++) {
      if (type[j] !== "0") {
        if (loading === false) {
          $.ajax({
            type: "POST",
            url: themeVars.adminUrl,
            data: {
              action: "load_tournament_brackets",
              id: ids[j],
              type: type[j],
            },
            beforeSend: function() {
              tables.forEach(function(el) {
                el.classList.remove("show");
              });
              loader.style.display = "flex";
            },
            success: function(result) {
              loader.style.display = "none";
              box.append(result);
              gridStandings();
              loading = true;
            },
            complete: function() {
              if (box.find(`[data-bracketid = ${ids[j]}]`).length) {
                loading = false;
              }
            },
          });
        }
      } else {
        if (loading === false) {
          // Load standings table
          let tournament_id = document
            .querySelector(".standings__bracket")
            .getAttribute("data-tournament");

          $.ajax({
            type: "POST",
            url: themeVars.adminUrl,
            data: {
              action: "load_table_standings",
              tournament_id: tournament_id,
              id: ids[j],
              gameID: gameID,
            },
            beforeSend: function() {
              loader.style.display = "flex";
            },
            success: function(result) {
              loader.style.display = "none";
              box.append(result);
              loading = true;
            },
            complete: function() {
              if (box.find(`[data-tableid = ${ids[j]}]`).length) {
                loading = false;
              }
            },
          });
        }
      }
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/Ajax-brackets.js